import { jwt } from "lib/jsonWebToken";
import PATHS from "routes/paths";
const AUTH_SERVICE_URL = process.env.REACT_APP_AUTH_SERVICE_URL;
const REACT_APP_URL = process.env.REACT_APP_URL;

const auth = {};

const runLocalStorageOperation = operation => {
  try {
    const storage = globalThis.localStorage;
    return storage ? operation(storage) : undefined;
  } catch {
    return undefined;
  }
};

auth.jwtDecoder = token => {
  if (!token) return {};

  const {
    team_id: teamId,
    sub: userId,
    roles,
    name,
    email,
    team_plan: teamPlan
  } = jwt.decode(token);

  return {
    teamId,
    userId,
    roles,
    name,
    email,
    teamPlan
  };
};

auth.setTokenInLocalStorage = value => {
  runLocalStorageOperation(storage => storage.setItem("auth_token", value));
};

auth.LOGIN_URL = [REACT_APP_URL, PATHS.login].join("");

auth.LOGOUT_URL = [
  AUTH_SERVICE_URL,
  "/session/end?",
  `post_logout_redirect_uri=${encodeURIComponent(REACT_APP_URL)}`
].join("");

auth.purgeLocalStorage = () => {
  runLocalStorageOperation(storage => storage.removeItem("auth_token"));
  runLocalStorageOperation(storage => storage.removeItem("accessToken"));
};

auth.findAToken = ({ state, history }) => {
  const storeToken = state.currentUser.token;
  if (storeToken) {
    return {
      tokenOrigin: "state",
      token: storeToken
    };
  }

  const localStorageToken = runLocalStorageOperation(storage =>
    storage.getItem("auth_token")
  );
  if (localStorageToken) {
    return {
      tokenOrigin: "localStorage",
      token: localStorageToken
    };
  }

  return {};
};

auth.getToken = ({ state, history }) => {
  const { token, tokenOrigin } = auth.findAToken({ state, history });

  if (!token) return {};

  auth.setTokenInLocalStorage(token);

  // TODO: CM start: See Git history for what to revert to
  let tokenClaims = {
    userId: null,
    teamId: null,
    roles: null
  };
  try {
    tokenClaims = auth.jwtDecoder(token);

    return {
      ...tokenClaims,
      tokenOrigin,
      token
    };
  } catch (err) {
    console.error("Failed to decode the provided auth token");
    return {
      ...tokenClaims,
      tokenOrigin,
      token: null
    };
  }
  // TODO: CM end
};

export default auth;
